import { createMetricSender } from '@/src/metrics/send-metric';
import { redirectToDeeplink } from '@/src/utils/deeplink';
import { getVendorRankType } from '@/src/utils/rankType/getVendorRankType';
import ProductCardVertical from '@pedidosya/web-fenix/businessComponents/ProductCardVertical';
import { COUNTRY_DISCOUNT_TAGS, DH_IMAGES, DTO, STATE } from '@utils/constants';
import {
  DEFAULT_ORIGIN_RESTAURANTS,
  restaurants as trackingRestaurants,
} from '@utils/tracking/restaurants/restaurants';
import { useState } from 'react';

const ProductCardWrapper = ({ item, vendor, index, isDesktop, location, platform, midasRequestId, redirectLink, ...props }) => {
  const metricSender = createMetricSender();
  const [state, setState] = useState(STATE.ENABLED);
  const onMouseEnterHandler = () => {
    if(isDesktop) setState(STATE.HOVER);
  };

  const onMouseLeaveHandler = () => {
    if(isDesktop) setState(STATE.ENABLED);
  };

  const redirectToWeb = async (url) => {
    document.location = url;
  };

  const onClickProduct = async (product) => {
    if (platform === 'web' || isDesktop || platform === 'unknown'|| platform === 'mweb') {
      setState(STATE.PRESSED);
      await redirectToWeb(`${vendor?.url}?p=${product?.id}`);
    } else {
      await metricSender.onDishRestaurantClicked();
      redirectToDeeplink(redirectLink)
    }
  };

  const onClickFunction = async () => {
    trackingRestaurants({
      type: 'product.clicked',
      payload: {
        product: item,
        vendor,
        origin: origin || DEFAULT_ORIGIN_RESTAURANTS,
        position: index,
        listedInfo: 'subsidized'
      },
    });

    trackingRestaurants({
      type: 'shop.clicked',
      payload: {
        shopId: vendor?.id,
        filterValue: location?.searchedLocation?.filterValue,
        screenType: DEFAULT_ORIGIN_RESTAURANTS,
        shopGoldVip: !(vendor?.labels?.sponsoringLabel === null || vendor?.labels?.sponsoringLabel === ''),
        ncrRequestToken: vendor?.ncrToken,
        shopSponsoring: getVendorRankType(vendor?.rankType),
        midasRequestId,
        shopSponsoringPlacement: 'shop_list:swimlane',
        currencyCode: location?.country?.currencyIsoCode,
        shopRatingQuality: vendor?.rating,
        shopName: vendor?.name,
        shopDeliveryFee: vendor?.delivery?.deliveryFee,
        shopDeliveryTime: vendor?.delivery?.deliveryTime,
        position: vendor?.rank,
        shopListBusinessType: 'Restaurants',
        shopDistance: vendor?.delivery?.distance,
        shopClickOrigin: 'swimlane',
        clickLocation: 'product_swimlane',
        discount: vendor?.labels?.discountLabel,
        productsDecorated: vendor?.productsDecorated,
        screenName: 'promotions-section-restaurants'
      },
    });

    await onClickProduct(item);
  };


  const tagDiscount = (countryId) => {
    const tag = COUNTRY_DISCOUNT_TAGS[countryId];
    return tag || DTO;
  };

  const renderPrice = (isFinalPrice = false) => {
    const price = isFinalPrice
      ? item?.price?.finalPrice
      : item?.price?.originalPrice;
    return `${item?.price?.currencyMask}${price?.toString()}`;
  };

  const renderTagDiscount = () => {
    if (item?.price?.discounts?.length > 0) {
      if (item?.price?.discounts[0]?.amount > 0) {
        return `${item?.price?.discounts[0]?.amount}% ${tagDiscount(
          location?.country?.id,
        )}`;
      }
    }
    return null;
  };

  const renderUrlImage = () => {
    if (item && item.images && item.images.length > 0 && item.images[0].url) {
      return `${DH_IMAGES}${item.images[0].url}`;
    }
    return '';
  };

  const renderProductName = (name) => {
    if (name?.length < 35) {
      const spacesToAdd = 36 - name.length;
      const spaces = ' '.repeat(spacesToAdd);
      return name + spaces;
    }
    return name;
  };

  return (
    <ProductCardVertical
      {...props}
      title={renderProductName(item?.name)}
      oldPrice={renderPrice()}
      finalPrice={renderPrice(true)}
      src={renderUrlImage()}
      labelTag={renderTagDiscount()}
      state={state}
      loading="eager"
      showPlusTag={item?.price?.discounts[0]?.isLoyalty}
      customProps={{
        ...props.customProps,
        onMouseEnter: onMouseEnterHandler,
        onMouseLeave: onMouseLeaveHandler,
        onClick: onClickFunction,
        style: {cursor: 'pointer', width: isDesktop && 168}
      }}
    />
  );
};

export default ProductCardWrapper;
